<template>
  <div id="chart">
    <apexchart type="bar" height="100%" :options="options" :series="series"></apexchart>
  </div>
</template>

<script>
import {nomeMeses} from "../../../../helpers/index";
import formatarValoresBi from "../../../../helpers/formatarValoresBi";
import {parametros_rota} from "../helpers/ParametrosRota";
import FornecedorAPI from "../../../../api/fornecedor.js";
import {formatarValorMonetario} from "../../../../helpers";

const serie_default = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

export default {
  name: "MovimentacaoEstoqueFornecedor",
  mixins: [parametros_rota],
  data: () => ({
    referencias: serie_default,
    series: [
      {
        name: 'Compras',
        data: serie_default,
        color: "rgba(4, 53, 84, 1)"
      }, {
        name: 'Vendas',
        data: serie_default,
        color: "rgba(214, 14, 43,1)",
      }
    ]
  }),
  computed: {
    excala_maxima() {
      const [compras, vendas] = this.series;

      const array_full = [].concat(compras.data, vendas.data)

      return Math.max(...array_full)
    },
    options() {
      return {
        chart: {
          type: "bar",
          fontFamily: "Roboto, Helvetica, Arial, sans-serif",
          toolbar: {
            show: false
          }
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%',
            endingShape: 'rounded',
            dataLabels: {
              position: "top",
              orientation: "vertical"
            }
          },
        },
        dataLabels: {
          enabled: true,
          offsetY: 3,
          style: {
            fontSize: "11px",
            fontWeight: 0,
            colors: ["#000"]
          },
          formatter: function(val) {
            return val > 0 ? `R$ ${formatarValoresBi(val)}` : '';
          }
        },
        grid: {
          show: true,
          yaxis: {
            lines: {
              show: true
            }
          },
          xaxis: {
            lines: {
              show: true
            }
          }
        },
        legend: {
          show: true,
          position: "top",
          offsetY: 10,
          markers: {
            width: 13,
            height: 13,
            radius: 0
          }
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"]
        },
        xaxis: {
          categories: this.referencias,
          style: {
            fontSize: "11px"
          },
          labels: {
            minWidth: 50,
            maxWidth: 50,
            formatter: mes => {
              if (mes === 0) return 'Mês';

              return (nomeMeses[mes - 1] || ' ').substring(0, 3);
            }
          },
        },
        yaxis: {
          title: {
            text: "Análise de Compras vs Vendas",
            style: {
              color: "#000",
              fontSize: "12px",
              fontWeight: 600,
              cssClass: "apexcharts-yaxis-title",
            },
          },
          labels: {
            minWidth: 50,
            maxWidth: 50,
            formatter: (n) => {
              return formatarValoresBi(n);
            }
          },
          forceNiceScale: true,
          max: this.excala_maxima + (this.excala_maxima / 3),
          min: 1,
        },
        fill: {
          opacity: 1
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return formatarValorMonetario(val)
            }
          },
          x: {
            show: true,
            formatter: val => {
              return nomeMeses[val - 1] || '';
            }
          },
        }
      }
    },
    PARAMETROS_INDICADOR() {
      const {grupo, filial, iddepartamento} = this.PARAMETROS;
      return {grupo, filial, iddepartamento};
    }
  },
  watch: {
    PARAMETROS_INDICADOR() {
      this.buscarMovimentacoesDepartamento();
    }
  },
  created() {
    this.buscarMovimentacoesDepartamento();
  },
  methods: {
    buscarMovimentacoesDepartamento() {
      const {grupo, filial, iddepartamento} = this.PARAMETROS;

      this.$store.dispatch('loading/addRequisicao',
        FornecedorAPI.buscarMovimentacoesDepartamento(grupo, filial, iddepartamento)
          .then(this.atualizarDadosGrafico)
      );
    },
    atualizarDadosGrafico({referencias, compras, saidas}) {
      this.referencias = referencias;

      this.series = [
        {
          name: 'Compras',
          data: compras,
          color: "rgba(4, 53, 84, 1)"
        }, {
          name: 'Vendas',
          data: saidas,
          color: "rgba(214, 14, 43,1)",
        }
      ]
    }
  }
}
</script>

<style scoped>
#chart {
  margin-top: -32px;
}
</style>
